import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import CopyZone from './CopyZone';

class ZoneHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copyModalOpened: false,
    };

    this._showCopy = this._showCopy.bind(this);
    this._hideCopy = this._hideCopy.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCopying && !nextProps.isCopying) {
      // Copy done, hiding modal
      this.setState({
        copyModalOpened: false,
      });
    }
  }

  _showCopy(evt) {
    evt.preventDefault();

    this.setState({
      copyModalOpened: true,
    });
  }

  _hideCopy() {
    this.setState({
      copyModalOpened: false,
    });
  }

  render() {
    const { copyModalOpened } = this.state;
    const { canAdd, onCopy, zoneTemplatesRef } = this.props;

    return (
      <h4 className="ui dividing header">
        Plan d'appâtage
        {canAdd && (
          <button
            className="ui right floated labeled icon button"
            onClick={this._showCopy}
          >
            <i className="icon undo" />
            Récupérer un lieu
          </button>
        )}
        {copyModalOpened && (
          <CopyZone
            onSubmit={onCopy}
            onClose={this._hideCopy}
            zoneTemplatesRef={zoneTemplatesRef}
          />
        )}
      </h4>
    );
  }
}

ZoneHeader.propTypes = {
  isCopying: PropTypes.bool.isRequired,
  onCopy: PropTypes.func.isRequired,
  canAdd: PropTypes.bool,
  zoneTemplatesRef: PropTypes.array.isRequired,
};

export default ZoneHeader;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/ZoneHeader.js